import React from "react";
import cvData from "../data/cvData.json";

const Hobbies = () => {
  const { hobbies } = cvData;

  return (
    <section id="hobbies" className="glass-panel glass-sheen p-6 md:p-8">
      <h2 className="section-title">Hobbies</h2>
      <div className="mt-6 flex flex-wrap gap-3">
        {hobbies.map((hobby, index) => (
          <span key={index} className="glass-chip">
            {hobby}
          </span>
        ))}
      </div>
    </section>
  );
};

export default Hobbies;
